export const items = [
    { label: "Transfers In", value: "/transfers/transfers-processing/in" },
    { label: "Transfers Out", value: "/transfers/transfers-processing/out" },
]

export const list = ["Fit", "New", "Total"]
export const labels = ["Fit", "New", "Processed", "Unprocessed", "Total"]
